import React from "react";
import { Divider, Grid } from "@mui/material";
import { StyledSignInWidget } from "./signInWidget.style";
import HlxButton from "component/commonComponents/button/button";

export interface ISignInWidgetProps {
  logo: string;
  content: string;
  button: React.ReactNode;
};

const Signinwidget: React.FC<ISignInWidgetProps> = (props) => {
  const { logo, content, button } = props;
  return (
    <StyledSignInWidget>
      <Grid xs={12} className="signinwidget-header">
        <img src={logo} alt="logo" title="logo" />
      </Grid>
      <Divider />
      <Grid xs={12} className="signinwidget-body">
        <div className="signinwidget-content">{content}</div>
        <div className="signinwidget-btn">{button}</div>
      </Grid>
    </StyledSignInWidget>
  )
};

export const defaultProps = {
  logo: "https://ok12static.oktacdn.com/fs/bco/1/fs0woruuvIgAGwAdl5d6",
  content: "Thanks for visiting UPtime!",
  button: <HlxButton label="Sign In" />
};

Signinwidget.defaultProps = defaultProps;

export default Signinwidget;